<script>
    import {protoSkills} from "../core.js"
    import {show_actionCard} from "../dialogs/OptionDialog.svelte";

		const cats = ['GP', 'GI', 'GS', 'GU', 'GN', 'GH', 'GK', 'G_', 'C', 'M', 'MA', 'ME', 'MM', 'MV']
				// ["Körperliche", "Geistige", "Soziale", "Stadt", "Natur", "Wissen", "Handwerk", "Sonstige",
				// 						"Kampf", "Magie", "Astral", "Elementar", "Mental", "Vital"]
		const catName =
				{ 'G': "Allgemeine", 'GP': "Körperliche", 'GI': "Geistige", 'GS': "Soziale",  'GN': "Natur", 'GU': "Stadt", 'GK': "Wissen", 'GH': "Handwerk", 'G_': "Neben",
          'C': "Kampf", 'CR': "Rollen", 'CW': "Waffen", 'B': "Biest",
          'M': "Magie", 'MA': "Astral", 'ME': "Elementar", 'MM': "Mental", 'MV': "Vital", }
    let groupedProfics = $derived(Object.groupBy(
			Object.entries(view.character.profics)
					// .filter(([skillID,value]) => !['mob', 'qic', 'acc', 'hvy', 'stf', 'cau', 'con', 'mem', 'far', 'sus', 'vig'].includes(skillID))
				.map(([skillID,value]) => ({ID: skillID, TYPE: 'skill', name: protoSkills[skillID]?.name, cat: protoSkills[skillID]?.cat ?? "Sonstige", skillname: protoSkills[skillID]?.name, includes: protoSkills[skillID]?.includes, value: value}))
				.sort((a,b) => (a.name < b.name) ? -1 : 1 )
	    , ({cat}) => cat)   )

    // $inspect(`SKILLSTAB - groupedProfics`, groupedProfics)

</script>


<!-------------------------------- HTML -------------------------------------->

<div class="tabContent" data-help="skills">
	{#each cats as cat}
		{@const group = catName[cat]}
    {#if groupedProfics[cat]?.length}
      <h3>{group}</h3>
      <table class="skillsTable">
        <tbody>
          {#each groupedProfics[cat] as profic (profic.ID)}
            <tr onclick={() => show_actionCard(profic.skillname, 'map', true)}>
              <td class=textCol>{profic.skillname}</td>
              <td class=textCol>{profic.includes}</td>
              <td class=numberCol>{profic.value}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}
	{:else }
        Der Charakter hat keine Fertigkeiten
	{/each}

	<div id="proficsTableBox"></div>

</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	#risk
		width: auto

	#skillPopup
		position: fixed
		z-index: 10
		width: 320px
		height: 180px
		top: calc(50% - 90px)
		left: calc(50% - 160px)
		background: hsl(150, 100%, 10%)
		padding: 0.5em

	#skillPopup .close,
	#actionCard .close
		color: #aaaaaa
		float: right
		font-size: 28px
		font-weight: bold

	#skillPopup .close:hover,
	#skillPopup .close:focus,
	#actionCard .close:hover,
	#actionCard .close:focus
		color: #000
		text-decoration: none
		cursor: pointer

	#skillDiceContainer,
	#abilityButtonBox
		display: flex
		justify-content: space-between
		padding: 16px 16px

</style>
